import { z } from 'zod'
import {
  CreateOrUpdateTransitOperationRequestAdditionalDeclarationTypeEnum,
  CreateOrUpdateTransitOperationRequestDeclarationTypeEnum,
  CreateOrUpdateTransitOperationRequestSecurityEnum,
} from 'api/models'

export const SecurityEnum = z.enum([
  CreateOrUpdateTransitOperationRequestSecurityEnum.S0,
  CreateOrUpdateTransitOperationRequestSecurityEnum.S1,
  CreateOrUpdateTransitOperationRequestSecurityEnum.S2,
  CreateOrUpdateTransitOperationRequestSecurityEnum.S3,
])
export const DeclarationTypeEnum = z.enum([
  CreateOrUpdateTransitOperationRequestDeclarationTypeEnum.T,
  CreateOrUpdateTransitOperationRequestDeclarationTypeEnum.T1,
  CreateOrUpdateTransitOperationRequestDeclarationTypeEnum.T2,
  CreateOrUpdateTransitOperationRequestDeclarationTypeEnum.T2F,
  CreateOrUpdateTransitOperationRequestDeclarationTypeEnum.TIR,
  CreateOrUpdateTransitOperationRequestDeclarationTypeEnum.T2SM,
  CreateOrUpdateTransitOperationRequestDeclarationTypeEnum.ENS,
])

export const AdditionalDeclarationTypeEnum = z.enum([
  CreateOrUpdateTransitOperationRequestAdditionalDeclarationTypeEnum.A,
  CreateOrUpdateTransitOperationRequestAdditionalDeclarationTypeEnum.B,
  CreateOrUpdateTransitOperationRequestAdditionalDeclarationTypeEnum.C,
  CreateOrUpdateTransitOperationRequestAdditionalDeclarationTypeEnum.D,
  CreateOrUpdateTransitOperationRequestAdditionalDeclarationTypeEnum.E,
  CreateOrUpdateTransitOperationRequestAdditionalDeclarationTypeEnum.F,
  CreateOrUpdateTransitOperationRequestAdditionalDeclarationTypeEnum.X,
  CreateOrUpdateTransitOperationRequestAdditionalDeclarationTypeEnum.Y,
  CreateOrUpdateTransitOperationRequestAdditionalDeclarationTypeEnum.Z,
  CreateOrUpdateTransitOperationRequestAdditionalDeclarationTypeEnum.O,
])

export type SecurityEnumT = z.infer<typeof SecurityEnum>

export const SubmitterSchema = z.object({
  telephone: z.string(),
})
export type Submitter = z.infer<typeof SubmitterSchema>
